import React from 'react';
import clsx from 'clsx';
import { Icons, Box, IconButton, Typography } from "@curves/ui-base";
import {paymentTypeImageMap} from '@icoach/memberDetail/staticData';
import PaymentUnsetAlert from '@icoach/memberDetail/components/PaymentUnsetAlert';

const BankPayment = ({ className, sourceData, onEdit }) => {
    const { title, paymentType = 1,  bankAccount, bankName, bankCode} = sourceData || {};

    const isNull = !bankAccount  ;
    return (
        <Box className={clsx('payment-card', className)}>
            <Typography className={'payment-card-title'} variant="h6">
                {title}
            </Typography>
            <IconButton className="payment-card-btn" onClick={onEdit}>
                <Icons.Edit />
            </IconButton>
            <Box className="payment-card-wrap">
                {isNull ? (
                    <PaymentUnsetAlert />
                ) : (
                    <React.Fragment>
                        <Box className="payment-card-img">
                            <img src={paymentTypeImageMap[paymentType]} alt="" />
                        </Box>
                        <Box className="payment-card-content">
                            <Typography className={'pt-0'} variant="body1" component={'h6'}>
                                {bankAccount}
                            </Typography>
                            <Typography className={'mb-1 font-color-3'} variant="body2">
                                {bankName ? `${bankName}` : '銀行名稱未設定'}
                            </Typography>
                            <Typography className={'mb-1 font-color-3'} variant="body2">
                                {bankCode ? `代號：${bankCode}` : '代號未設定'}
                            </Typography>
                        </Box>
                    </React.Fragment>
                )}
            </Box>
        </Box>
    );
};

export default BankPayment;
